import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class TopicMobileDevices extends BaseIcon {
  getChildren = () => [
    <g fill={ this.getColor() } fillRule='evenodd'>
      <path
        d="M13.56,5H3.44A1.41,1.41,0,0,0,2,6.38V22.63A1.41,1.41,0,0,0,3.44,24H13.56A1.41,1.41,0,0,0,15,22.63V6.38A1.41,1.41,0,0,0,13.56,5ZM13,21.36a.64.64,0,0,1-.64.64H4.64A.64.64,0,0,1,4,21.36V7.64A.64.64,0,0,1,4.64,7H5a.64.64,0,0,1,.64.64.65.65,0,0,0,.64.65h4.5a.65.65,0,0,0,.64-.65A.64.64,0,0,1,12,7h.33a.64.64,0,0,1,.64.64Z"/>
      <path
        d="M20.56,0H10.44A1.41,1.41,0,0,0,9,1.38V4h2V2.64A.64.64,0,0,1,11.64,2H12a.64.64,0,0,1,.64.64.65.65,0,0,0,.64.65h4.5a.65.65,0,0,0,.64-.65A.64.64,0,0,1,19,2h.33a.64.64,0,0,1,.64.64V16.36a.64.64,0,0,1-.64.64H16v2h4.56A1.41,1.41,0,0,0,22,17.63V1.38A1.41,1.41,0,0,0,20.56,0Z"/>
    </g>
  ]
  getViewBox = () => '0 0 24 24'
}
